import type { RouteRecordRaw } from "vue-router";
import ComingSoon from "@/pages/ComingSoon.vue";

/**
 * Placeholders de módulos futuros na área de Xestión.
 * Roles: directiva / admin.
 * Actividades: ver módulo Activities.
 */
export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "gestion/propuestas",
    name: "proposals",
    component: ComingSoon,
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.proposals",
      subtitleKey: "comingSoon.proposals",
      icon: "Lightbulb",
    },
  },
  {
    path: "gestion/subvenciones",
    name: "grants",
    component: ComingSoon,
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.grants",
      subtitleKey: "comingSoon.grants",
      icon: "Banknote",
    },
  },
  {
    path: "gestion/actuaciones",
    name: "actions",
    component: ComingSoon,
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.actions",
      subtitleKey: "comingSoon.actions",
      icon: "ClipboardCheck",
    },
  },
  {
    path: "gestion/actas",
    name: "minutes",
    component: ComingSoon,
    meta: {
      roles: ["ADMIN", "TECNICO"],
      titleKey: "menu.minutes",
      subtitleKey: "comingSoon.minutes",
      icon: "NotebookPen",
    },
  },
];
